<template>
  <div>
    <custom-callout
      controlled
      has-toggle
      :opened="value.opened"
      @click:open="toggle()"
    >
      <div class="row">
        <div :class="`row d-flex align-items-center py-2 pr-3 col-12`">
          <div class="col-12 col-md">
            <div class="data-name">Estatus:</div>
            <div>
              <custom-balloon
                :background-color="value.status.color"
                dot
                :text="value.status.name"
              />
            </div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Número de Batch:</div>
            <div>{{ value.number | empty }}</div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Fecha de Creación:</div>
            <div>{{ value.date | date }}</div>
          </div>

          <div class="col-12 col-md-2 d-flex justify-content-end">
            <drop-down :items="actions" />
          </div>

          <div class="w-100 px-3">
            <hr />
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Cantidad de Reclamaciones:</div>
            <div>{{ value.count | empty }}</div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Monto a Reclamar:</div>
            <div>{{ value.totalAmount | currency }}</div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Lugar de Servicio:</div>
            <div>{{ value.location?.name | empty }}</div>
          </div>

          <div class="col-12 col-md-2" />
        </div>
      </div>
      <template #edition>
        <div class="bg-secondary-3 p-2">
          <div v-if="areTabsVisible" class="bg-white p-2 c-tabs">
            <b-tabs
              v-model="currentIndexTab"
              active-nav-item-class="mipe-tab font-weight-bold text-mipe-orange mipe-active-tab"
              active-tab-class=""
              content-class="mt-3"
              nav-class="mipe-tab"
              :no-nav-style="true"
            >
              <b-tab
                :active="currentIndexTab === tabValue.History"
                title="Historial de Estatus"
                @click="onActiveTab(tabValue.History)"
              >
                <batch-history :item="value" />
              </b-tab>
              <b-tab
                :active="currentIndexTab === tabValue.Documents"
                title="Documentos"
                @click="onActiveTab(tabValue.Documents)"
              />
            </b-tabs>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//utils
import medicaidBatchStatus from '@/utils/constants/medicaidBatchStatus';
import moment from 'moment';

//services
import { changeBatchStatus } from '@/modules/medicaid/medicaid-claim.api';

//components
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';

//local components
import BatchHistory from './BatchHistory.vue';

//constants
const TABS = Object.freeze({
  History: 0,
  Documents: 1,
});

import ClaimsTabs from '@/utils/constants/claimsTabs';

export default {
  name: 'BatchResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    BatchHistory,
  },
  filters: {
    time(value) {
      return value ? moment(value, 'HH:mm:ss').format('hh:mm A') : '-';
    },
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    checkable: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      currentIndexTab: null,
    };
  },
  computed: {
    tabValue() {
      return TABS;
    },
    areTabsVisible() {
      return [TABS.History, TABS.Documents].includes(this.currentIndexTab);
    },
    isCancellable() {
      return (
        this.value.status.id === medicaidBatchStatus.Draft &&
        this.userHasPermissions('provider.medicaid.claims.batch.cancel')
      );
    },
    actions() {
      return [
        {
          name: 'enter',
          label: 'Entrar',
          icon: 'fas fa-file-import text-green',
          click: () => this.goToDetail(),
        },
        {
          name: 'cancel',
          label: 'Cancelar',
          visible: this.isCancellable,
          icon: 'fas fa-times-circle text-danger',
          click: () => this.changeStatus(medicaidBatchStatus.Cancelled),
        },
        {
          name: 'history',
          label: 'Historial de Estatus',
          icon: 'fas fa-history text-green',
          click: () => {
            this.openTabs(TABS.History);
          },
        },
      ];
    },
  },
  methods: {
    openTabs(tabIndex) {
      this.currentIndexTab = Number(tabIndex);
      this.value.opened = true;
    },
    toggle() {
      const willClose = this.value.opened === true;

      this.value.opened = !this.value.opened;

      if (willClose) {
        this.currentIndexTab = null;
      }
    },
    onActiveTab(indexTab) {
      this.currentIndexTab = Number(indexTab);
    },
    cancel() {
      this.currentIndexTab = null;
      this.value.opened = false;
    },
    async changeStatus(status) {
      const batchNumber = this.value?.number ?? '';

      let message = {
        success: 'Estatus actualizado exitosamente',
        confirmation: `¿Está seguro que desea cambiar el estatus del batch ${batchNumber}?`,
        error:
          'No fue posible actualizar el batch. Intente nuevamente o contacte al administrador.',
      };

      switch (status) {
        case medicaidBatchStatus.Cancelled:
          message = {
            success: 'Batch cancelado exitosamente',
            confirmation: `¿Está seguro que desea cancelar el batch ${batchNumber}?`,
            error:
              'No fue posible cancelar el batch. Intente nuevamente o contacte al administrador.',
          };
          break;

        // case medicaidBatchStatus.Submitted:
        //   message = {
        //     success: 'Batch enviado exitosamente',
        //     confirmation: `¿Está seguro que desea enviar el batch ${batchNumber}?`,
        //     error:
        //       'No fue posible enviar el batch. Intente nuevamente o contacte al administrador.',
        //   };
        //   break;

        default:
          this.ShowToast(
            'Atención',
            'Acción no válida para este estatus.',
            'error'
          );
          return;
      }

      const confirmation = await this.ShowCancelModal(
        'Confirmación',
        message.confirmation,
        'Si',
        'No'
      );

      if (!confirmation) return;

      try {
        await changeBatchStatus(this.value.id, { status });
        this.$emit('refresh');
        this.ShowToast('Éxito', message.success, 'success');
      } catch (error) {
        this.ShowToast('Atención', message.error, 'error');
      }
    },
    goToDetail() {
      this.$router.push({
        name: 'medicaid-claims-batch',
        params: { id: this.value.id },
        query: { tab: ClaimsTabs.Reclamaciones },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bg-green-gray {
  background-color: #ebf1ee !important;
}
.c-tabs {
  ::v-deep .nav-link.active {
    color: #2db782;
    padding-bottom: 5px;
    border-bottom: 3px #2db782 solid !important;
  }
  ::v-deep ul.mipe-tab {
    display: flex;
    width: 100%;
  }

  ::v-deep ul.mipe-tab .nav-item {
    flex: 1;
    text-align: center;
  }
}
</style>
